<template>
  <div class="event">
    <div class="section1">
      <div class="item" :class="roomId == item.id ? 'active' : ''" v-for="(item, index) in elList" :key="index"
        @click="roomId = item.id">
        <div>{{ item.roomName }}</div>
      </div>
      <div class="time">
        <span>日期选择：</span>
        <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
        </el-date-picker>
      </div>
    </div>
    <div class="section2">
      <div class="left common">
        <div class="title">事件统计</div>
        <div class="count">
          <p>事件总数</p>
          <div class="cright">
            <p>{{ alarms.alarmTotal }}</p>
            <p>项</p>
          </div>
        </div>
        <div class="progress">
          <div class="item1"></div>
          <div class="item2" :style="{
                width: (alarms.alarmHandle / alarms.alarmTotal) * 100 + '%',
              }"></div>
          <div class="item3" :style="{
                width: (alarms.alarmUnHandle / alarms.alarmTotal) * 100 + '%',
              }"></div>
        </div>
        <div class="info">
          <div class="item">
            <div class="legend">
              <div class="color"></div>
              <p>报警总数</p>
            </div>
            <div class="number">
              <p>{{ alarms.alarmTotal }}</p>
              <p>项</p>
            </div>
          </div>
          <div class="item">
            <div class="legend">
              <div class="color color2"></div>
              <p>已确认报警</p>
            </div>
            <div class="number">
              <p>{{ alarms.alarmHandle }}</p>
              <p>项</p>
            </div>
          </div>
          <div class="item">
            <div class="legend">
              <div class="color color3"></div>
              <p>未确认报警</p>
            </div>
            <div class="number">
              <p>{{ alarms.alarmUnHandle }}</p>
              <p>项</p>
            </div>
          </div>
        </div>
      </div>
      <div class="br"></div>
      <div class="middle common">
        <div class="title">设备分类统计</div>
        <div class="box">
          <div class="chart-box">
            <v-chart :option="option"></v-chart>
          </div>
          <div class="legend">
            <div class="item">
              <div class="color"></div>
              <p>高压主进表</p>
            </div>
            <div class="item">
              <div class="color color2"></div>
              <p>低压主进表</p>
            </div>
            <div class="item">
              <div class="color color5"></div>
              <p>高压回路表</p>
            </div>
            <div class="item">
              <div class="color color3"></div>
              <p>低压回路表</p>
            </div>
            <div class="item">
              <div class="color color4"></div>
              <p>直流屏</p>
            </div>
            <div class="item">
              <div class="color color6"></div>
              <p>综保</p>
            </div>
            <div class="item">
              <div class="color color7"></div>
              <p>温控</p>
            </div>
            <div class="item">
              <div class="color color8"></div>
              <p>温湿度</p>
            </div>
            <div class="item">
              <div class="color color9"></div>
              <p>水浸</p>
            </div>
            <div class="item">
              <div class="color color10"></div>
              <p>视频</p>
            </div>
          </div>
        </div>
      </div>
      <div class="br"></div>
      <div class="right common">
        <div class="title">报警次数TOP</div>
        <div class="change-box">
          <div class="item" v-for="(item, index) in timeList" :key="index" :class="timeIndex == index ? 'active' : ''"
            @click="timeIndex = index">
            {{ item }}
          </div>
        </div>
        <div class="table-box ss">
          <el-table :data="tableData" style="width: 100%;height:220px;overflow: auto;">
            <el-table-column prop="date" label="排名" width="50">
              <template slot-scope="scope">
                <div class="number" :class="scope.row.number == 1 ? 'color1' : ''">
                  {{ scope.row.number }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="roomName" label="配电室"> </el-table-column>
            <el-table-column prop="cabinetNum" label="配电柜编号">
            </el-table-column>
            <el-table-column prop="equipmentDesc" label="回路名称">
            </el-table-column>
            <el-table-column prop="alarmCount" width="100" label="报警次数">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="section3">
      <div class="title">报警列表</div>
      <div class="table-box big">
        <!-- eventType == item.value ? 'active' : ''    ,'font-color'+index-->
        <div class="item-box">
          <div class="item" v-for="(item, index) in eventOptions" :key="index"
            :class="eventType == item.value ? 'active' : ''" @click="changeType(item)">
            <div :class="'font-color'+index">{{ item.label }}</div>
          </div>
        </div>
        <el-table ref="multipleTable" :data="tableData2" tooltip-effect="dark" @sort-change="changeTableSort"
          v-loading="tableLoading" :row-style="setRowStyle" style="width: 100%" height="450">
          <el-table-column label="序号" type="index" width="80" align="center">
          </el-table-column>
          <el-table-column prop="roomName" width="120" label="配电室">
          </el-table-column>
          <el-table-column prop="equipmentCode" width="250" label="现场编号">
          </el-table-column>
          <el-table-column prop="alarmValue" width="130" label="告警值">
          </el-table-column>
          <el-table-column prop="code" width="130" label="设备编号" v-if="menuChildren.indexOf('175') > -1">
          </el-table-column>
          <el-table-column prop="alarmDesc" label="报警描述"> </el-table-column>
          <!-- <el-table-column prop="name" label="设备描述"> </el-table-column>
          <el-table-column prop="name" label="设备位置"> </el-table-column> -->
          <el-table-column prop="alarmTypeValue" width="280" label="事件类型">
            <template slot-scope="scope">
              <div class="type-box">
                <p>{{ scope.row.alarmType | filterType}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="alarmTime" :sortable="'custom'" :sort-orders="['ascending', 'descending']" width="180"
            label="报警时间">
          </el-table-column>
          <!-- <el-table-column prop="type" width="80" label="报警类型">
<template slot-scope="scope">
  <div class="type-box">
    <div class="type" :class="scope.row.alarmValueType == 1 ? 'color1' : ''"></div>
    <p>{{ scope.row.alarmValueType == 1 ? "告警" : "异常" }}</p>
  </div>
</template>
          </el-table-column> -->
          <el-table-column prop="handleTime" v-if="eventType==='1'" width="180" label="确认时间">
          </el-table-column>
          <el-table-column prop="handler" label="确认人" v-if="eventType==='1'" width="120">
          </el-table-column>
          <el-table-column prop="name" label="事件状态" width="80">
            <template slot-scope="scope">
              <div class="type-box">
                <p>{{ scope.row.status == 1 ? "已处理" : "未处理" }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div class="btn-out-box">
                <div class="btn-box download" :title="scope.row.status===1?'查看':'处理'" @click="editselfHandle(scope)">
                  <i class="iconfont icon-youxiang"></i>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          :total="total"
          @current-change="paginationHandle"
        >
        </el-pagination> -->
        <el-pagination class="m-t-lg" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" align="right" background :page-sizes="[10, 20, 50, 100]" :page-size="size"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
        <!-- <div class="info">
          <div class="left">第 2 页（共108页），显示1至10项结果，共1,006项</div>
          <div class="right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage4"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="400"
            >
            </el-pagination>
          </div>
        </div> -->
      </div>
      <div class="event-type">
        <span>报警类型：</span>
        <el-select v-model="eventType1" placeholder="全部" @change="changeType1">
          <el-option v-for="item in eventOptions1" :key="item.id" :label="item.alarmDesc" :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="600px" :close-on-click-modal="true">
      <!-- :append-to-body="false" -->
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- :modal-append-to-body="false" -->
    <el-dialog title="报警处理信息" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :modal-append-to-body="false">
      <div class="name">{{ alarmInfo.roomName }}</div>
      <div class="br"></div>
      <section>
        <span class="label">报警描述：</span>
        <span class="info">{{ alarmInfo.alarmDesc }}</span>
      </section>
      <section>
        <span class="label">配电柜编号：</span>
        <span class="info inline">{{ alarmInfo.equipmentCode }}</span>
      </section>
      <section>
        <span class="label">报警时间：</span>
        <span class="info inline">{{ alarmInfo.alarmTime }}</span>
      </section>
      <div class="br"></div>
      <section>
        <p class="label mb10">确认人</p>
        <el-input placeholder="请输入" v-model="input2" :readonly="alarmInfo.status == 1" show-word-limit maxlength="50">
        </el-input>
      </section>
      <section>
        <p class="label mb10">处理信息</p>
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" :readonly="alarmInfo.status == 1"
          maxlength="1000" show-word-limit placeholder="请输入内容" v-model="textarea2">
        </el-input>
      </section>
      <section>
        <p class="label mb10">处理图片 <span class="tips-txt">*仅支持上传JPEG，PNG格式图像文件，最多支持9张</span></p>
        <el-upload v-if="alarmInfo.status == 0" action="https://jsonplaceholder.typicode.com/posts/" ref="upload"
          accept=".jpg,.jpeg,.png" :on-exceed="handleExceed" list-type="picture-card" multiple :limit="9"
          :auto-upload="false" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
          :on-change="handleChange">
          <i class="el-icon-plus"></i>
        </el-upload>

        <div class="img-box" v-else>
          <!-- 切换到已处理，无法请求了数据但是界面没有变化 -->
          <div v-if="alarmInfo.imageUrls">
            <img :src="item" alt="" v-for="(item, index) in alarmInfo.imageUrls.split(',')" @click="open(item)"
              :key="index" />
          </div>
        </div>
        <!-- :modal-append-to-body="false" -->

      </section>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updata" v-if="alarmInfo.status == 0">提 交</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

  // import {
  //   Message
  // } from 'element-ui';
  import ECharts from "vue-echarts";
  import qs from "qs";
  export default {
    components: {
      "v-chart": ECharts,
    },
    data () {
      return {
        menuChildren: [],
        dialogFormVisible: false,
        timeList: ["日", "月", "年"],
        tableLoading: false,
        timeIndex: 0,
        currentPage: 1,
        // upfil:process.env.VUE_APP_API_UPFILES+'/appVersionUpdate/updateVersionQRCode',
        total: 0,
        size: 10,
        date: "",
        option: {
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)",
          },
          color: [
            "rgba(86, 180, 252, 1)",
            "rgba(51, 204, 141, 1)",
            "rgba(20, 96, 224, 1)",
            "rgba(252, 131, 86, 1)",
            "rgba(252, 208, 86, 1)",
            "rgba(86, 180, 252, 0.5)",
            "rgba(51, 204, 141, 0.5)",
            "rgba(252, 131, 86, 0.5)",
            "rgba(252, 208, 86, 0.5)",
            "rgba(20, 96, 224, 0.5)",
          ],
          series: [
            {
              name: "设备分类",
              type: "pie",
              radius: ["50%", "80%"],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "25",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              data: [],
            },
          ],
        },
        tableData: [],
        tableData2: [],
        currentPage4: 4,
        eventOptions1: [
          // {
          //   value: "0",
          //   label: "全部",
          // },
          // {
          //   value: "1",
          //   label: "分闸",
          // },
          // {
          //   value: "2",
          //   label: "合闸",
          // },
          // {
          //   value: "3",
          //   label: "跳闸",
          // },
        ],
        eventOptions: [
          {
            value: "-1",
            label: "全部",
          },
          {
            value: "0",
            label: "未处理",
          },
          {
            value: "1",
            label: "已处理",
          },
        ],
        eventType: "0",
        elList: [],
        roomId: -1,
        alarms: {},
        textarea2: "",
        input2: "",
        eventType1: "",
        orderBy: "",
        fileList: [],
        alarmInfo: {},
        timeType: 0,
        dialogImageUrl: "",
        dialogVisible: false,
      };
    },
    filters: {
      filterType (v) {
        let SwitchName = "";
        switch (v) {
          case 1:
            SwitchName = "设备过载";
            break;
          case 2:
            SwitchName = "设备重载";
            break;
          case 3:
            SwitchName = "设备低限";
            break;
          case 4:
            SwitchName = "设备低低限";
            break;
          case 5:
            SwitchName = "闭合";
            break;
          case 6:
            SwitchName = "断开";
            break;
          case 7:
            SwitchName = "恢复";
            break;
          case 8:
            SwitchName = "异常断开";
            break;
          case 9:
            SwitchName = "异常闭合";
            break;
          default:
            SwitchName = " ";
        }
        return SwitchName;
      },
    },
    created () {
      this.menuChildren = localStorage.getItem("menuSon").split(",");
      this.orderBy = "desc";
      this.date = this.$dateFormat("YYYY-mm-dd", new Date());
      this.projectId = this.$getCookie("projectId");
      // 时时监控
      this.searchEquipmentRoomList();
      // 事件统计/事件分类统计
      this.searchAlarmCountStatistics();
      // top5
      this.timeType = 0;
      this.searchAlarmTopStatistics();
      // 获取报警类型
      this.getAlarmType();
      // 告警列表
      this.searchAlarmContents();
    },
    watch: {
      roomId () {
        this.currentPage = 1;
        this.searchAlarmCountStatistics();
        this.searchAlarmContents();
      },
      timeIndex (n, o) {
        this.timeType = n;
        this.searchAlarmTopStatistics();
      },
      dialogFormVisible (v) {
        if (!v) {
          this.$nextTick(() => {
            this.$refs.upload.clearFiles();
          });
        }
      },
      date () {
        this.searchAlarmCountStatistics();
        this.searchAlarmContents();
      },
    },
    computed: {
      title1 () {
        if (this.eventType == 0) {
          return "处理";
        } else {
          return "查看";
        }
      },
    },
    methods: {
      changeType (v) {
        this.currentPage = 1;
        this.eventType = v.value;
        this.searchAlarmContents();
        this.searchAlarmCountStatistics();
      },
      changeTableSort (column) {
        // console.log(column);
        var sortingType = column.order;
        this.currentPage = 1;
        //按照降序排序
        if (sortingType == "descending") {
          this.orderBy = "desc";
          this.searchAlarmContents();
          // this.tableData = this.tableData.sort((a, b) => b[fieldName] - a[fieldName]);
        }
        //按照升序排序
        else {
          this.orderBy = "asc";
          this.searchAlarmContents();
          // this.tableData = this.tableData.sort((a, b) => a[fieldName] - b[fieldName]);
        }
        // // console.log(this.tableData);
      },
      getAlarmType () {
        this.$http
          .post("bma-distribution-service/alarmConfig/searchAlarmConfigs")
          .then((res) => {
            if (res.data) {
              this.eventOptions1 = res.data;
              let newDate = {
                alarmType: "全部",
                alarmDesc: "全部",
                id: 0,
              };
              this.eventOptions1.unshift(newDate);
            }
          });
      },
      changeType1 (v) {
        this.currentPage = 1;
        this.eventType1 = v;
        this.searchAlarmContents();
        this.searchAlarmCountStatistics();
        // alert('等待接口对接')
      },
      handleExceed (files, fileList) {
        this.$message.warning(`当前限制只能上传9张图片！`);
      },
      setRowStyle ({ row, rowIndex }) {
        let styleObj = {};
        // console.log(row);
        // console.log(rowIndex);
        // if (rowIndex === 1) {
        //   // console.log('jin')
        //   styleObj.color= '#e21918!important';
        //   return styleObj;
        // } else {
        //   return "";
        // }
        // alert(this.eventType)
        // 已处理
        // if (row.status === 1) {
        //   styleObj.color = "rgba(51, 204, 141, 1)!important";
        //   return styleObj;
        //   // 未处理
        // } else if (row.status === 0) {
        //   styleObj.color = "#fc5959!important";
        //   return styleObj;
        //   // 全部
        // } else {
        //   styleObj.color = "#152139!important";
        //   return styleObj;
        // }
        // 已处理
        if (row.eventType === "1") {
          styleObj.color = "rgba(51, 204, 141, 1)!important";
          return styleObj;
          // 未处理
        } else if (row.eventType === "0") {
          styleObj.color = "#fc5959!important";
          return styleObj;
          // 全部
        } else {
          styleObj.color = "#152139!important";
          return styleObj;
        }
      },
      open (item) {
        this.dialogVisible = true;
        this.dialogImageUrl = item;
      },
      handleSizeChange (val) {
        this.size = val;
        this.searchAlarmContents();
        this.searchAlarmCountStatistics();
        this.searchAlarmTopStatistics();
      },
      handleCurrentChange (val) {
        this.currentPage = val;
        this.searchAlarmContents();
        this.searchAlarmCountStatistics();
        this.searchAlarmTopStatistics();
      },
      // 时时监控
      searchEquipmentRoomList () {
        this.$http
          .post(
            "bma-distribution-service/equipmentRoom/searchEquipmentRoomListForOverview",
            {
              projectId: this.projectId,
            }
          )
          .then((res) => {
            if (res.data) {
              let arr = [];
              arr = res.data;
              arr.unshift({
                roomName: "全部",
                id: -1,
              });
              this.elList = arr;
            }
          });
      },
      // 事件统计/设备分类统计
      searchAlarmCountStatistics () {
        let params = {
          time: this.date,
        };
        if (this.roomId == -1) {
          params.projectId = this.projectId;
        } else {
          params.roomId = this.roomId;
        }
        this.$http
          .post(
            "bma-distribution-service/alarm/searchAlarmCountStatistics",
            params
          )
          .then((res) => {
            this.alarms = res.data;
            let arr = [
              {
                name: "高压主进表",
              },
              {
                name: "低压主进表",
              },
              {
                name: "高压回路表",
              },
              {
                name: "低压回路表",
              },
              {
                name: "直流屏",
              },
              {
                name: "综保",
              },
              {
                name: "温控",
              },
              {
                name: "温湿度",
              },
              {
                name: "水浸",
              },
              {
                name: "视频",
              },
            ];
            arr.forEach((item, index) => {
              item.value = res.data.eqTypeAlarmCounts[index + 1];
            });
            this.option.series[0].data = arr;
          });
      },
      // top5
      searchAlarmTopStatistics () {
        // 时间类型 1.本日 2.本月 3.本年
        let dateType = this.timeType + 1;
        this.$http
          .post("bma-distribution-service/alarm/searchAlarmTopStatistics", {
            dateType: dateType,
            projectId: this.projectId,
          })
          .then((res) => {
            // console.log(res);
            if (res.data) {
              res.data.forEach((item, index) => {
                item.number = index + 1;
              });
              this.tableData = res.data;
            }
          });
      },
      // 告警列表
      searchAlarmContents () {
        this.tableLoading = true;
        let params = {
          time: this.date,
          status: this.eventType,
          currentPage: this.currentPage,
          alarmType: this.eventType1,
          orderBy: this.orderBy,
          size: this.size,
        };
        if (this.roomId == -1) {
          params.projectId = this.projectId;
        } else {
          params.roomId = this.roomId;
        }
        this.$http
          .post("bma-distribution-service/alarm/searchAlarmContents", params)
          .then((res) => {
            // this.tableData2 = res.data.records;
            let getDate = res.data.records;
            getDate.forEach((item) => {
              item.eventType = this.eventType;
            });
            this.total = res.data.total;
            this.tableData2 = getDate;
            this.tableLoading = false;
          });
      },
      // 确认告警
      editselfHandle (e) {
        // console.log("e: ", e);
        // 清空
        this.input2 = "";
        this.textarea2 = "";
        this.fileList = [];
        // 复制
        this.alarmInfo = e.row;
        if (e.row.status == 1) {
          this.input2 = e.row.handler;
          this.textarea2 = e.row.handleResult;
        }
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.$refs.upload.clearFiles();
        });
      },
      updata () {
        if (this.textarea2 == "" || this.input2 == "") {
          this.$message.warning("请输入处理人和处理意见");
          return;
        }
        let formData = new FormData();
        for (var i = 0; i < this.fileList.length; i++) {
          // files[i] = this.fileList[i].raw;
          formData.append("multipartFiles", this.fileList[i].raw);
        }
        formData.append("alarmId", this.alarmInfo.id);
        formData.append("equipmentCode", this.alarmInfo.equipmentCode);
        formData.append("handleResult", this.textarea2);
        formData.append("handler", this.input2);
        // console.log(this.fileList);
        this.$http
          .post("bma-distribution-service/alarm/handleAlarm", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.code == 200) {
              let that = this
              that.$message.success("提交成功");
              that.searchAlarmCountStatistics();
              that.searchAlarmContents();
              that.dialogFormVisible = false;
            } else {
              this.$message.error("提交失败");
            }
          });
      },
      handleChange (file, fileList) {
        this.fileList = fileList;
        let testFile = file.name
          .substring(file.name.lastIndexOf(".") + 1)
          .toLowerCase();
        // console.log(testFile);
        const isJPG =
          testFile === "jpeg" ||
          testFile === "jpg" ||
          testFile === "png" ||
          testFile === "PNG" ||
          file.type === "JPG";
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG或者PNG 格式!");
          if (fileList.length > 0) {
            this.fileList.pop();
          } else {
            this.fileList = [];
          }
          return false;
          // this.fileUploadList = []
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 1M!");
          if (fileList.length > 0) {
            this.fileList.pop();
          } else {
            this.fileList = [];
          }
          return false;
        }
        return isJPG && isLt2M;
      },
      handleRemove (file, fileList) {
        // console.log(file, fileList);
      },
      handlePictureCardPreview (file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
    },
  };
</script>

<style lang="less" scoped>
  .event {
    background: #ececec;
    padding-bottom: 15px;
    width: calc(100% - 40px);

    .el-table::before {
      z-index: inherit;
    }

    /deep/.table-box {
      width: 500px;

      &.big {
        width: 100%;
        margin-top: 20px;

        .type-box {
          display: flex;
          align-items: center;
          justify-content: center;

          .type {
            width: 8px;
            height: 8px;
            background: #fc5959;
            border: 1px solid #ffd1d1;
            border-radius: 50%;
            margin-right: 8px;

            &.color1 {
              background: #fc9856;
              border: 1px solid #ffdbc4;
            }
          }
        }

        .btn-out-box {
          display: flex;
          justify-content: space-around;
        }

        .btn-box {
          width: 24px;
          height: 24px;
          background: rgba(165, 165, 165, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .iconfont {
            font-size: 12px;
            color: rgba(195, 195, 195, 1);
          }

          &.editself.active {
            background: rgba(235, 126, 52, 0.1);

            .iconfont {
              color: rgba(235, 126, 52, 1);
            }
          }

          &.editself:hover {
            background: rgba(235, 126, 52, 0.1);

            .iconfont {
              color: rgba(235, 126, 52, 1);
            }
          }

          &.download.active {
            background: rgba(20, 96, 224, 0.1);

            .iconfont {
              color: rgba(20, 96, 224, 1);
            }
          }

          &.download:hover {
            background: rgba(20, 96, 224, 0.1);

            .iconfont {
              color: rgba(20, 96, 224, 1);
            }
          }
        }

        tr {
          td {
            padding: 12px 0 !important;
          }
        }
      }

      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;

        .left {
          font-size: 12px;
          color: rgba(137, 146, 159, 1);
        }
      }

      .el-table {
        background: rgba(0, 0, 0, 0);

        .cell {
          text-align: center;
        }

        .number {
          width: 40px;
          height: 22px;
          border-radius: 4px;
          text-align: center;
          line-height: 22px;
          font-size: 12px;
          color: rgba(236, 103, 103, 1);
          background: rgba(247, 245, 241, 1);
          display: inline-block;

          &.color1 {
            background: #f9f1f1;
          }
        }

        th,
        tr {
          background: rgba(0, 0, 0, 0);
        }

        th {

          // border: none !important;
          >.cell {
            color: #152139;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
          }
        }

        tr {
          td {
            // border: none !important;
            padding: 6px 0;
            text-align: center;
            font-size: 14px; // color: #152139;
          }
        }
      }

      &.ss {
        .el-table {
          th {
            >.cell {
              color: #152139;
              font-size: 14px;
              font-weight: 400;
              text-align: center;
            }
          }

          tr {
            td {
              // border: none !important;
              padding: 6px 0;
              text-align: center;
              font-size: 14px;
              font-weight: 600;
              color: #152139;

              div {
                font-weight: 600;
              }
            }
          }
        }
      }
    }

    .section1 {
      background: #f8f8f9;
      padding: 20px;
      padding-bottom: 0;
      display: flex;
      position: relative;
      width: 100%;

      .time {
        position: absolute;
        right: 30px;
        top: 5px;
      }

      .item {
        display: flex;
        margin-right: 20px;

        >div {
          color: #0e223d;
          font-size: 16px;
          cursor: pointer;
          width: 90px;
          text-align: center;
          padding-bottom: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &.active {
          >div {
            font-weight: 600;
            border-bottom: 3px solid #1460e0;
          }
        }
      }
    }

    .section2 {
      margin-left: 15px;
      margin-top: 15px; // width: 1635px;
      width: 100%;
      height: 300px;
      background: #f8f8f9;
      box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.04);
      border-radius: 7px;
      padding: 25px;
      box-sizing: border-box;
      display: flex;

      .common {
        .title {
          color: #152139;
          font-weight: 600;
          letter-spacing: 2px;
          font-size: 20px;
          text-align: left;
        }
      }

      .left {
        width: 45%; // width: 484px;

        .count {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          margin-top: 20px;

          >p {
            font-size: 20px;
            color: #152139;
          }

          >.cright {
            align-items: baseline;
            display: flex;

            p {
              &:first-of-type {
                margin-right: 34px;
                font-size: 56px;
                color: #212e43;
                font-weight: 600;
              }

              &:last-of-type {
                font-size: 16px;
                color: #152139;
              }
            }
          }
        }

        .progress {
          margin-top: 26px;
          width: 100%;
          border-radius: 9px;
          background: rgba(203, 203, 203, 0.3);
          display: flex;
          height: 12px;
          overflow: hidden;

          >div {
            height: 12px;
          }

          .item1 {
            width: 0%;
            background: rgba(236, 103, 103, 1);
          }

          .item2 {
            width: 100%;
            background: rgba(252, 152, 86, 1);
          }

          .item3 {
            width: 0%;
            background: rgba(254, 222, 200, 1);
          }
        }

        .info {
          margin-top: 30px;
          display: flex;
          justify-content: space-between;

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;

            .legend {
              display: flex;
              align-items: center;

              .color {
                width: 20px;
                height: 5px;
                background: #ec6767;
                margin-right: 10px;

                &.color2 {
                  background: #fc9856;
                }

                &.color3 {
                  background: #fedec8;
                }

                p {
                  font-size: 16px;
                  color: #152139;
                }
              }
            }

            .number {
              display: flex;
              align-items: baseline;
              margin-top: 25px;

              p {
                &:first-of-type {
                  font-size: 26px;
                  font-weight: 600;
                  color: #212e43;
                  margin-right: 30px;
                }
              }
            }
          }
        }
      }

      .middle {
        width: 44%;

        .box {
          display: flex;
          align-items: center;

          .chart-box {
            width: 220px;
            height: 220px;
          }

          .legend {
            width: 300px;
            height: 150px;
            display: flex;
            flex-wrap: wrap;

            .item {
              width: 150px;
              display: flex;
              align-items: center;

              .color {
                width: 10px;
                height: 10px;
                background: rgba(86, 180, 252, 1);
                margin-right: 8px;

                &.color2 {
                  background: rgba(51, 204, 141, 1);
                }

                &.color3 {
                  background: rgba(252, 131, 86, 1);
                }

                &.color4 {
                  background: rgba(252, 208, 86, 1);
                }

                &.color5 {
                  background: rgba(20, 96, 224, 1);
                }

                &.color6 {
                  background: rgba(86, 180, 252, 0.5);
                }

                &.color7 {
                  background: rgba(51, 204, 141, 0.5);
                }

                &.color8 {
                  background: rgba(252, 131, 86, 0.5);
                }

                &.color9 {
                  background: rgba(252, 208, 86, 0.5);
                }

                &.color10 {
                  background: rgba(20, 96, 224, 0.5);
                }
              }
            }
          }
        }
      }

      @media screen and (max-width: 1440px) {
        .common {
          .title {
            font-size: 16px;
          }
        }

        .left {
          width: 40%;

          .count {
            >p {
              font-size: 16px;
            }

            >.cright {
              p {
                &:first-of-type {
                  font-size: 45px;
                }

                &:last-of-type {
                  font-size: 16px;
                  color: #152139;
                }
              }
            }
          }
        }

        .middle {
          width: 25%;
        }
      }

      .right {
        position: relative;

        .change-box {
          display: flex;
          justify-content: space-between;
          width: 100px;
          position: absolute;
          top: 0px;
          right: 30px;

          .item {
            font-size: 10px;
            cursor: pointer;
            color: #717789;
            padding-bottom: 14px;

            &.active {
              color: #1460e0;
              border-bottom: 3px solid #1460e0;
            }
          }
        }
      }

      .br {
        width: 0px;
        height: 128px;
        border: 1px solid #eeeeef;
        margin: 0 24px;
        margin-top: 70px;
      }
    }

    .section3 {
      margin-left: 15px;
      margin-top: 20px; // width: 1635px;
      width: 100%;
      height: 660px;
      padding: 25px;
      box-sizing: border-box;
      background: #f8f8f9;
      box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.04);
      border-radius: 7px;
      position: relative;

      .item-box {
        flex-direction: row;
        display: flex;
        margin: 25px 0px 15px 0px;

        .item {
          display: flex;
          margin-right: 20px;

          >div {
            color: #0e223d;
            font-size: 16px;
            cursor: pointer;
            width: 90px;
            text-align: center;
            padding-bottom: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          &.active {
            >div {
              font-weight: 600;
              border-bottom: 3px solid;
            }
          }
        }
      }

      .title {
        color: #152139;
        font-weight: 600;
        letter-spacing: 2px;
        font-size: 20px;
        text-align: left;
      }

      .event-type {
        position: absolute;
        right: 50px;
        top: 30px;
        display: flex;
        align-items: center;

        span {
          width: 90px;
        }

        /deep/.el-select {
          width: 250px;

          .el-input__inner {
            background-color: rgba(0, 0, 0, 0);
            border: none;
          }

          input::placeholder {
            color: #0e223d;
            font-size: 16px;
            font-weight: 600;
          }
        }
      }
    }
  }

  .el-pagination {
    margin-top: 20px;
    text-align: center;
  }

  .tips-txt {
    color: red;
    font-size: 14px;
    margin-left: 4px;
  }

  /deep/.el-dialog {
    .el-dialog__title {
      font-weight: 600;
      font-size: 20px;
      color: #152139;
    }

    .name {
      font-size: 26px;
      font-weight: 600;
      color: #152139;
    }

    .eventType {
      font-size: 16px;
      line-height: 27px;
      color: #152139;
      margin-top: 10px;
    }

    .br {
      width: 100%;
      height: 0px;
      border: 1px solid #e4e4e4;
      margin: 20px 0;
    }

    section {
      margin: 8px 0;

      .label {
        font-size: 16px;
        font-weight: 300;
        line-height: 27px;
        color: #152139;
      }

      .info {
        font-size: 16px;
        font-weight: 600;
        line-height: 27px;
        color: #152139;

        &.inline {
          width: 180px;
          display: inline-block;
        }
      }
    }

    .mb10 {
      margin-bottom: 10px;
    }

    .img-box {
      img {
        width: 120px;
        margin-right: 15px;
      }
    }
  }

  .font-color1 {
    color: #fc5959 !important;
  }

  .font-color2 {
    color: rgba(51, 204, 141, 1) !important;
  }

  .font-color0 {
    color: #152139 !important;
  }
</style>